var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-6 pt-5 pt-md-8 bg-dark"},[_c('hr')]),_c('b-container',{staticClass:"mt--6",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"line-numbers":false,"search-options":{
              enabled: true,
              placeholder: 'Buscar en los registros'
            },"pagination-options":{
              enabled: true,
              mode: 'records',
              perPage: 15,
              perPageDropdown: [15, 25, 50],
              dropdownAllowAll: false,
              setCurrentPage: 2,
              nextLabel: 'Siguiente',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Registros por página',
              ofLabel: 'de',
              pageLabel: 'páginas', // for 'pages' mode
              allLabel: 'All'
            },"styleClass":"tableOne text-left vgt-table condensed","selectOptions":{
              enabled: false,
              selectionInfoClass: 'table-alert__box'
            },"fixed-header":true,"row-style-class":"text-left","rows":_vm.rows}},[_c('div',{staticClass:"mb-3",attrs:{"slot":"table-actions"},slot:"table-actions"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"to":"/catalogos/sucursales/nuevo","variant":"primary"}},[_vm._v("\n                Agregar\n              ")])],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }